var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5307_60025)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.83203,
    y: 4.83789,
    width: 102.645,
    height: 6.83333,
    transform: "rotate(45 4.83203 4.83789)",
    fill: "#230050"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.084 17.0837V70.041C17.084 74.756 20.9107 78.5827 25.6257 78.5827H52.959C57.674 78.5827 61.5007 74.756 61.5007 70.041V61.5004L54.6673 54.6671V61.4993H23.9173V23.917L17.084 17.0837ZM54.6673 45.0033V13.666H23.9173V14.2533L17.9244 8.26034C19.3035 5.39507 22.2349 3.41602 25.6257 3.41602H52.959C57.674 3.41602 61.5007 7.24268 61.5007 11.9577V51.8366L54.6673 45.0033ZM34.1673 70.041C34.1673 72.8768 36.4565 75.166 39.2923 75.166C42.1282 75.166 44.4173 72.8768 44.4173 70.041C44.4173 67.2052 42.1282 64.916 39.2923 64.916C36.4565 64.916 34.1673 67.2052 34.1673 70.041Z",
    fill: "#230050"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5307_60025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.f7f3fb6e47b0f3ce203fb29dc4d4e3ef.svg";
export { ForwardRef as ReactComponent };